<template>
  <div v-loading="loading" class="drawer" style="height: calc(100vh - 60px);">
    <div v-show="isHistoryShow" class="drawer-meng" @click="isHistoryShow = false"></div>
    <CommonSearch
      ref="CommonSearch"
      style="border-bottom:none"
      :search-label="searchLabel"
      :show-history-dialog="isHistoryShow"
      @showHistory="isHistoryShow = true"
      @doSearch="defaultSearch"
      @goBack="goBack"
      @changeSearchType="changeSearchType"
    >
    </CommonSearch>
    <div v-show="result.length > 0" class="drawer-result">
      <el-alert title="以下只优先展示20条，如果您想要查看更多，请点击资源库中心，进入中心搜索！" type="info">
      </el-alert>
      <div class="drawer-box">
        <el-table :data="result" size="mini">
          <el-table-column label="文件名" prop="originalname" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                v-html="
                  scope.row.highlights && scope.row.highlights['originalname']
                    ? scope.row.highlights['originalname'][0]
                    : scope.row['originalname']
                "
              >
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <i class="iconfont icon-view" title="预览" @click="preview(scope.row)"></i>
              <!-- <i class="iconfont icon-download" title="下载" @click="download(scope.row)"></i> -->
              <i
                v-if="scope.row.rid"
                class="iconfont icon-search"
                title="查看人选"
                @click="showFileRadish(scope.row)"
              ></i>
              <i
                v-else-if="!scope.row.isGua"
                class="iconfont icon-plus"
                title="绑定人选"
                @click="showLink(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="repository-btn-box">
      <span class="radish-btn radish-btn-primary radish-btn-small" @click="toListdocuments">进入资源库搜索中心</span>
    </div>

    <LinkFile
      :visible.sync="linkFileVisible"
      :link-target="linkTarget"
      :search-keywords="linkTarget.originalname"
      @onLink="linkFile"
    />
  </div>
</template>
<script>
import { LinkFile } from '../../../../project'

import { download } from '../../../../project/src/constant/utils'
import CommonSearch from '../searchBar/CommonSearch'
import { searchLabel2Value, searchPlaceHolder } from '../constant/utils'

const searchLabel = '资源库'
export default {
  components: { CommonSearch, LinkFile },
  data: function() {
    return {
      searchLabel: searchLabel,
      searchType: searchLabel2Value[searchLabel],
      placeHolder: searchPlaceHolder[searchLabel],
      keywords: '',
      result: [],
      isHistoryShow: false,
      linkTarget: {},
      linkFileVisible: false,
      loading: false,
    }
  },
  computed: {
    download() {
      return download
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.keywords = ''
      this.result = []
      this.loading = false
    },
    goBack() {
      this.$emit('goBack')
    },
    toListdocuments() {
      const keywords = this.$refs.CommonSearch.keywords
      window.open(`${window.frontend}/#/listdocuments${keywords ? `?keywords=${keywords}` : ''}`, '_blank')
    },
    changeSearchType(type) {
      this.$emit('searchTypeChange', type)
    },
    setSearchHistory() {
      this.searchHistory = localStorage.searchHistory ? JSON.parse(localStorage.searchHistory) : {}
      if (!this.searchHistory[this.searchType]) this.searchHistory[this.searchType] = []
      if (!this.searchHistory[this.searchType].includes(this.keywords)) {
        this.searchHistory[this.searchType].unshift(this.keywords)
        localStorage.searchHistory = JSON.stringify(this.searchHistory)
      }
    },
    async doSearch() {
      if (!this.keywords) return this.$message.info('请输入搜索内容')
      this.setSearchHistory()
      this.isHistoryShow = false
      this.loading = true
      try {
        await app.service('misc').insertSearchHistory({ type: searchLabel, keywords: this.keywords })
      } catch (e) {}
      const res = await app
        .service('misc')
        .searchEs({ type: this.searchType, keywords: this.keywords, fields: ['originalname', 'content'] })
      if (res.status === 'success') {
        if (res.data.length === 0) this.$message.info('没有符合条件的结果')
        else this.result = res.data.splice(0, 20)
      } else this.$message.error(res.msg)
      this.loading = false
    },
    defaultSearch({ type, keywords, result }) {
      this.searchType = type
      this.keywords = keywords
      this.$refs.CommonSearch.keywords = keywords
      if (result) {
        this.result = result
      } else {
        this.$nextTick(() => {
          this.doSearch()
        })
      }
    },
    async preview(file) {
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      ref.getFile(file)
      ref.show()
    },
    async showFileRadish(file) {
      const opts = { id: file.rid }
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    showLink(row) {
      this.linkTarget = row
      this.linkFileVisible = true
    },
    linkFile(item) {
      this.result = this.result.map(res => {
        if (res._id === this.linkTarget._id) {
          if (item.idField === 'rid') {
            res.rid = item.id
          } else {
            res.isGua = true
          }
        }
        return res
      })
      this.linkFileVisible = false
    },
  },
}
</script>
<style scoped>
.repository-btn-box {
  padding: 10px;
  display: flex;
  justify-content: center;
}
</style>
